import { __rest } from 'tslib';
import { jsx, Fragment } from 'react/jsx-runtime';
import React__default from 'react';
import { styled } from '@mui/material/styles';
import MuiSwitch from '@mui/material/Switch';
import MuiTypography from '@mui/material/Typography';
import Label from '../Label/Label.js';

const _Toggle = styled(MuiSwitch)(({ theme, size, checked, disabled }) => `
  .MuiSwitch-thumb {
    background-color: ${theme.palette[disabled ? 'N10' : 'white'].main};
    ${checked && size === 'small' && `border-color: ${theme.palette.primary.dark} !important`};
  }
`);
const ToggleWrapper = styled(Label, { shouldForwardProp: prop => prop !== 'size' }) `
  ${({ size }) => size === 'medium' &&
    `
    flex-direction: row-reverse;
  `}
`;
const labelSizes = (theme) => ({
    medium: theme.spacing(0, 2, 0, 0),
    small: theme.spacing(0, 0, 0, 2.5),
});
const Text = styled(MuiTypography, { shouldForwardProp: prop => prop !== 'size' }) `
  ${({ theme, size = 'medium' }) => `
    margin: ${labelSizes(theme)[size]};
  `}
`;
const Toggle = (_a) => {
    var { disabled, size = 'medium', children, hint, hintDuration, className, 'data-testid': testId } = _a, rest = __rest(_a, ["disabled", "size", "children", "hint", "hintDuration", "className", 'data-testid']);
    return (jsx(ToggleWrapper, Object.assign({ disabled: disabled, className: className, size: size, hint: hint, hintDuration: hintDuration, control: jsx(_Toggle, Object.assign({ size: size, disabled: disabled, "data-testid": testId }, rest)) }, { children: children && (jsx(Fragment, { children: React__default.isValidElement(children) ? (children) : (jsx(Text, Object.assign({ variant: "h5", size: size }, { children: children }))) })) })));
};

export { Toggle as default };
//# sourceMappingURL=Toggle.js.map
